{
  "login": {
    "tagline": "Lighter class\nmanagement.",
    "description": "Students, attendance, tuition — all in one platform built for Vietnamese teachers and tutors.",
    "title": "Sign in",
    "subtitle": "Welcome back. Enter your credentials to continue.",
    "or": "or",
    "email": "Email",
    "password": "Password",
    "passwordPlaceholder": "Enter password",
    "forgotPassword": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in...",
    "noAccount": "Don't have an account?",
    "signUp": "Start free trial",
    "invalidCredentials": "Invalid email or password.",
    "noOrganization": "You no longer belong to any organization."
  },
  "register": {
    "tagline": "Start managing\nyour classes.",
    "description": "Create an account and try free for 30 days — no card required.",
    "title": "Create account",
    "subtitle": "Fill in the details below to get started with LopHoc.app.",
    "fullName": "Full name",
    "fullNamePlaceholder": "John Doe",
    "email": "Email",
    "password": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "orgName": "Class / center name",
    "orgNamePlaceholder": "e.g. Ms Hanh's Math Class",
    "submit": "Create account",
    "submitting": "Creating account...",
    "hasAccount": "Already have an account?",
    "signIn": "Sign in",
    "emailExists": "This email is already in use.",
    "consent": "By creating an account, you agree to our",
    "consentTerms": "Terms of Service",
    "consentAnd": "and",
    "consentPrivacy": "Privacy Policy"
  },
  "forgotPassword": {
    "title": "Forgot password",
    "subtitle": "Enter your email and we'll send you a reset link.",
    "submit": "Send reset link",
    "submitting": "Sending...",
    "successTitle": "Check your email",
    "successMessage": "If the email exists in our system, we've sent a password reset link. Please check your inbox.",
    "backToLogin": "Back to sign in"
  },
  "resetPassword": {
    "title": "Reset password",
    "subtitle": "Enter a new password for your account.",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "confirmPlaceholder": "Re-enter password",
    "submit": "Reset password",
    "submitting": "Processing...",
    "successTitle": "Password reset successful",
    "successMessage": "You can now sign in with your new password.",
    "minLength": "Password must be at least 8 characters.",
    "mismatch": "Passwords do not match.",
    "invalidToken": "Invalid token. Please try again from your email."
  },
  "verifyEmail": {
    "verifying": "Verifying your email...",
    "pleaseWait": "Please wait a moment.",
    "successTitle": "Email verified",
    "successMessage": "Your account is ready. Sign in to continue.",
    "errorTitle": "Verification failed",
    "errorMessage": "The verification link is invalid or has expired.",
    "missingToken": "Missing verification code",
    "missingTokenMessage": "Please use the link from your email to verify."
  },
  "invite": {
    "title": "Join the class",
    "subtitle": "Set your name and a password to accept the invite and join.",
    "fullName": "Full name",
    "fullNamePlaceholder": "Jane Doe",
    "password": "Password",
    "passwordHint": "If you already have an account with this email, just set any password — we only add you to the class.",
    "submit": "Join",
    "submitting": "Working...",
    "successTitle": "You're in!",
    "successMessage": "You've been added to the class. Sign in to continue.",
    "minLength": "Password must be at least 8 characters.",
    "invalidToken": "Invalid token. Please try again from the email."
  }
}
